module.exports = __webpack_public_path__ + "static/media/e.b8a10be4.png";